import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetThemeCommand } from '@/app/theme/commands/get-theme.command'

const httpClient = new AxiosClient()

export const getThemeCommand = new GetThemeCommand(httpClient, store)
